export default __webpack_public_path__ + "static/media/atmospherePositive.c48e6d98.webp";